export const formatDate = (date) => {
  if (!date) return "";

  try {
    // Aceita YYYY-MM-DD e também datetime ISO (YYYY-MM-DDTHH:mm:ss...)
    if (typeof date === "string") {
      const isoMatch = date.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);

      if (isoMatch) {
        const [, year, month, day] = isoMatch;
        return `${day}/${month}/${year}`;
      }
    }

    // Se vier no formato YYYY-MM-DD (backend)
    if (typeof date === "string" && date.includes("-")) {
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    }

    // fallback para outros formatos
    return new Date(date).toLocaleDateString("pt-BR");
  } catch {
    return date;
  }
};
